import { useEffect, useState } from 'react';
import './organizations-compare.css';
import { Button } from '../../widgets/button/button';
import { ReactComponent as CompareIcon } from '../../../assets/compare.svg';
import { Loading } from '../../widgets/loading/loading';
import { useNavigation } from '../../../contexts/navigation-context';
import { OrganizationCompare } from '../../widgets/organization-compare/organization-compare';

export const OrganizationsComparePage = ({ activities }) => {
  const [organizationData, setOrganizationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { currentPage, to, back } = useNavigation();

  const loadOrganization = async (organizationId) => {
    const result = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${organizationId}`);
    return await result.json();
  };

  const loadOrganizations = async () => {
    setIsLoading(true);
    const orgData = [];
    for (let organizationId of currentPage?.params?.organizationIds) {
      orgData.push(await loadOrganization(organizationId));
    }
    setOrganizationData(orgData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (currentPage?.pageId === 'organizations-compare') {
      loadOrganizations();
    }
  }, [currentPage]);

  const handleFinishCompareClicked = () => {
    back();
  };

  return (
    <>
      <div className="organizations-compare-page">
        <div className="page-header">
          <div className="page-title">Compare Organizations</div>
          <div className="page-header-button-container">
            <Button icon={<CompareIcon />} color="highlight" onClick={handleFinishCompareClicked}>
              Finish comparing
            </Button>
          </div>
        </div>
        {isLoading && (
          <div className="organizations-compare-loading-container">
            <Loading />
          </div>
        )}
        {!isLoading && (
          <div className="organizations-compare-container">
            {organizationData.length === 0 && (
              <div className="organizations-compare-empty-message">No organizations found that meet the currently selected filters</div>
            )}
            {organizationData.length > 0 &&
              organizationData.map((o) => <OrganizationCompare key={o.EIN} organization={o} activities={activities}></OrganizationCompare>)}
          </div>
        )}
      </div>
    </>
  );
};
